(() => {
  const configElement = document.getElementById('lc-opening-hours-exception-data');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const calendar = new Intl.DateTimeFormat('en-US', {
    timeZone: config.time_zone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    weekday: 'short'
  });
  const weekdays = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const regularHours = {
    Mon: '10:00–17:00', Tue: '10:00–17:00', Wed: '10:00–17:00',
    Thu: '10:00–17:00', Fri: '10:00–17:00', Sat: '12:00–15:00'
  };

  function updateHours() {
    const parts = Object.fromEntries(calendar.formatToParts(new Date()).map(part => [part.type, part.value]));
    const today = `${parts.year}-${parts.month}-${parts.day}`;
    const closed = today === config.date;
    document.querySelectorAll('[data-lc-hours-notice]').forEach(notice => {
      notice.hidden = today > config.date;
    });
    document.querySelectorAll('[data-lc-hours-regular]').forEach(time => {
      time.textContent = closed ? time.dataset.lcHoursClosed : time.dataset.lcHoursRegular;
    });
    document.querySelectorAll('#lc-ft [data-days]').forEach(row => {
      const isToday = row.dataset.days.split(',').includes(String(weekdays[parts.weekday]));
      row.classList.toggle('is-today', isToday);
      const label = row.querySelector('.lc-ft__today');
      if (label) label.hidden = !isToday;
    });
    document.querySelectorAll('[data-lc-ch-today]').forEach(status => {
      const hours = closed ? null : regularHours[parts.weekday];
      status.textContent = `${status.dataset.label}: ${hours || status.dataset.closed}`;
      status.classList.toggle('is-closed', !hours);
      status.hidden = false;
    });
  }

  updateHours();
  document.addEventListener('shopify:section:load', updateHours);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateHours();
  });
  setInterval(updateHours, 60000);
})();
